// extracted by mini-css-extract-plugin
module.exports = {"link":"DefaultLink_link__LEwz_"};